import React from "react";
import { Link } from "react-router-dom";

export default function PageNavBarLinks(props) {
  const {
    item: { routeName, link },
  } = props;
  return <Link className="nav-link" to={link}>{routeName}</Link>;
}
